import QRCode from 'qrcodejs2'
import PaymentInfo from '@/views/cost-center/components/PaymentInfo'
import {
  getPrePay,
  generateDimensionalZfbCode,
  generateDimensionalWxCode,
  getOrderStatus,
} from '@/utils/api/order'
export default {
  components: {
    PaymentInfo,
  },
  data() {
    return {
      orderData: {}, // 订单信息
      maskTime: null, // 二维码遮罩倒计时
      isMask: false, // 是否遮罩住二维码
      pollingTime: null, // 轮询定时器
      qrCodeText: '', // 二维码内容
      maskLoading: false, // 刷新按钮是否在loading状态
      qrCodeInstance: null, // 二维码实例
      isDestroy: false, // 组件是否销毁
      pollingStop: false, // 轮询是否停止
    }
  },
  methods: {
    // 创建二维码
    async creatQrCode() {
      try {
        // 判断是微信还是支付宝，根据类型调用不同的接口
        const request =
          this.type === 1
            ? generateDimensionalZfbCode
            : generateDimensionalWxCode

        const { rspResult, data } = await request({
          outTradeNo: this.orderData.paymentNo,
        })
        if (rspResult.bizCode === 200) {
          this.isMask = false
          this.qrCodeText = data.qrCode
          // 创建新的二维码
          this.newQRCode(data.qrCode)
          // 设置定时器
          this.setTime()
        }
      } catch (err) {
        console.error('❌ ~ file: payment.js:45 ~ creatQrCode ~ err:', err)
        this.isMask = true
      }
    },

    // 获取订单状态、支付单状态、是否过期
    async getStatus() {
      try {
        const { rspResult, data } = await getOrderStatus({
          outTradeNo: this.orderData.paymentNo,
        })
        if (rspResult.bizCode === 200) {
          // 订单状态为待支付
          if (data.orderStatus === 10) {
            // 二维码已过期 - 重新请求订单信息和二维码
            if (data.expired) {
              this.stopTime()
              this.$refs.qrCode.innerHTML = ''
              this.isMask = true
              return this.getOrder()
            }
            
            // 二维码未过期 - 继续轮询
            if (this.pollingStop) return // 如果已经停止, 将不再继续轮询
            // 待支付 && 未过期 自己调用自己继续轮询
            this.pollingTime = setTimeout(() => {
              // 判断 如果组件已经销毁，直接return掉 (防止即使内存泄露时也不会一直调用服务)
              if (this.isDestroy) {
                return this.stopTime()
              }
              this.getStatus()
            }, 1000)
            return
          }

          // 如果订单已支付 且 支付单已支付，代表是当前页支付单进行的支付，跳转到支付成功
          if (data.orderStatus === 20 && data.paymentStatus === 20) {
            return this.$router.push({
              name: 'const-center-payment-success',
            })
          }

          // 其余情况，直接去订单列表页
          this.$router.push({
            name: 'const-center-my-order',
          })
        }
      } catch (err) {
        console.error('❌ ~ file: payment.js:93 ~ getStatus ~ err:', err)
      }
    },

    // 请求订单信息
    async getOrder() {
      try {
        const { rspResult, data } = await getPrePay({
          orderNo: this.$route.params.orderNo,
          paymentType: this.type === 1 ? 10 : 20,
        })
        if (rspResult.bizCode === 200) {
          this.orderData = data
          // 根据订单信息生成二维码
          this.creatQrCode()
        } else if(rspResult.bizCode === 600) {
          this.$message.error('请求过于频繁，请稍后再试')
        } else {
          // 订单状态异常跳转到 我的订单 列表
          this.$message.error(rspResult.message)
          this.$router.push({
            name: 'const-center-my-order',
          })
        }
      } catch (err) {
        console.error('❌ ~ file: payment.js:112 ~ getOrder ~ err:', err)
      }
    },

    // 刷新二维码
    refresh() {
      // maskLoading 避免重复点击
      if (this.maskLoading) return
      this.maskLoading = true

      this.isMask = false
      this.$nextTick(() => {
        try {
          this.newQRCode(this.qrCodeText)
          this.setTime()
        } catch (err) {
          console.error(
            '❌ ~ file: payment.js:131 ~ this.$nextTick ~ err:',
            err
          )
          this.isMask = true
        }
      })
    },

    // 设置定时器
    async setTime() {
      this.stopTime() // 每次设置定时器之前，将之前的销毁
      this.pollingStop = false
      this.getStatus() // 手动获取一次订单状态，开启轮询

      // 开启定时器，1分钟后遮掉二维码
      this.maskTime = setTimeout(() => {
        this.$refs.qrCode.innerHTML = ''
        this.isMask = true
        this.maskLoading = false
        this.stopTime()
      }, 1000 * 60)
    },

    // 清除定时器
    stopTime() {
      try {
        this.pollingStop = true
        clearTimeout(this.maskTime)
        this.maskTime = null
        clearTimeout(this.pollingTime)
        this.pollingTime = null
      } catch(err) {
        console.error("❌ ~ file: payment.js:167 ~ stopTime ~ err:", err)
      }
    },

    // 创建二维码实例
    newQRCode(text) {
      try {
        this.qrCodeInstance = new QRCode(this.$refs.qrCode, {
          text: text, // 需要转换为二维码的内容
          width: 143,
          height: 143,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      } catch(err) {
        console.error("❌ ~ file: payment.js:182 ~ newQRCode ~ err:", err)
        this.$message.error('生成二维码失败，请稍后重试')
        this.isMask = true
      }
    },
  },
  async mounted() {
    this.getOrder()
    this.isDestroy = false
  },

  beforeDestroy() {
    this.stopTime()
    this.isDestroy = true
    if (this.qrCodeInstance) {
      this.qrCodeInstance.clear()
      this.qrCodeInstance = null
    }
  },

  deactivated() {
    this.stopTime()
    this.isDestroy = true
    if (this.qrCodeInstance) {
      this.qrCodeInstance.clear()
      this.qrCodeInstance = null
    }
  },
}
